(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq').forEach(function (section) {
      var buttons = Array.prototype.slice.call(section.querySelectorAll('.faq-item__question'));

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var isOpen = button.getAttribute('aria-expanded') === 'true';
          var wrapper = document.getElementById(button.getAttribute('aria-controls'));

          // Cierra cualquier otra pregunta abierta antes de abrir la seleccionada.
          buttons.forEach(function (otherButton) {
            if (otherButton === button) return;
            otherButton.setAttribute('aria-expanded', 'false');
            var otherWrapper = document.getElementById(otherButton.getAttribute('aria-controls'));
            if (otherWrapper) otherWrapper.classList.remove('is-open');
          });

          button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (wrapper) wrapper.classList.toggle('is-open', !isOpen);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener(
        'change',
        this.setHeaderHeight.bind(this)
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(
          this.hide.bind(this)
        );
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(
            this.isScrolling
          );

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll(
          'header-menu'
        );

      this.disclosures.forEach(
        (disclosure) => disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector(
          'details-modal'
        );

      this.searchModal.close(false);
    }
  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  /* =========================================================
     HEADER TRANSPARENTE -> OSCURO AL HACER SCROLL
     ========================================================= */
  (function () {
    var header =
      document.querySelector(
        '[data-transparent-header]'
      );

    if (!header) return;

    var darkenDelay =
      parseInt(
        header.getAttribute(
          'data-scroll-distance'
        ),
        10
      );

    if (isNaN(darkenDelay)) {
      darkenDelay = 0;
    }

    var isPinned = false;
    var pinnedAtScrollY = 0;
    var ticking = false;

    function getScrollTop() {
      return (
        window.pageYOffset ||
        document.documentElement.scrollTop
      );
    }

    function refreshHeightVar() {
      var wasPinned = isPinned;

      if (wasPinned) {
        header.classList.remove(
          'header-wrapper--pinned',
          'header-wrapper--scrolled'
        );
      }

      document.documentElement.style.setProperty(
        '--transparent-header-height',
        header.offsetHeight + 'px'
      );

      if (wasPinned) {
        header.classList.add(
          'header-wrapper--pinned'
        );

        if (
          getScrollTop() >=
          pinnedAtScrollY + darkenDelay
        ) {
          header.classList.add(
            'header-wrapper--scrolled'
          );
        }
      }
    }

    function update() {
      var scrollTop = getScrollTop();

      if (!isPinned) {
        if (
          header.getBoundingClientRect().top <= 0
        ) {
          isPinned = true;

          pinnedAtScrollY = scrollTop;

          header.classList.add(
            'header-wrapper--pinned'
          );
        }
      } else if (
        scrollTop <= pinnedAtScrollY - 4
      ) {
        isPinned = false;

        pinnedAtScrollY = 0;

        header.classList.remove(
          'header-wrapper--pinned',
          'header-wrapper--scrolled'
        );
      }

      if (isPinned) {
        header.classList.toggle(
          'header-wrapper--scrolled',
          scrollTop >=
            pinnedAtScrollY + darkenDelay
        );
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    refreshHeightVar();
    update();

    window.addEventListener(
      'scroll',
      onScroll,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      refreshHeightVar
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.testimonials');

    sections.forEach(function (section) {
      var viewport = section.querySelector('.testimonials__viewport');
      var track = section.querySelector('.testimonials__track');
      if (!viewport || !track) return;

      var originalItems = Array.prototype.slice.call(track.children);
      if (originalItems.length < 2) return;

      // Clona la primera y la última tarjeta para poder rotar sin saltos (loop infinito).
      var firstClone = originalItems[0].cloneNode(true);
      var lastClone = originalItems[originalItems.length - 1].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      lastClone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      track.insertBefore(lastClone, originalItems[0]);
      track.appendChild(firstClone);

      var items = Array.prototype.slice.call(track.children);
      var index = 1; // arranca en la primera tarjeta real (después del clon inicial)
      var interval = parseInt(section.dataset.autoplayInterval, 10) || 0;
      var timer = null;
      var gapPx = 0;

      function readGap() {
        var style = window.getComputedStyle(track);
        gapPx = parseFloat(style.columnGap || style.gap || '0') || 0;
      }

      function offsetTo(targetIndex) {
        var offset = 0;
        for (var i = 0; i < targetIndex; i++) {
          offset += items[i].getBoundingClientRect().width + gapPx;
        }
        return offset;
      }

      function setPosition(animate) {
        readGap();
        var card = items[index];
        var centerOffset = (viewport.clientWidth - card.getBoundingClientRect().width) / 2;
        var translate = centerOffset - offsetTo(index);

        if (!animate) {
          track.classList.remove('is-animating');
        } else {
          track.classList.add('is-animating');
        }
        track.style.transform = 'translateX(' + translate + 'px)';
      }

      function goNext() {
        index += 1;
        setPosition(true);
      }

      function goPrev() {
        index -= 1;
        setPosition(true);
      }

      function goTo(targetIndex) {
        if (targetIndex === index) return;
        index = targetIndex;
        setPosition(true);
      }

      track.addEventListener('transitionend', function (event) {
        if (event.propertyName !== 'transform') return;
        var current = items[index];
        if (current && current.hasAttribute('aria-hidden')) {
          index = index === items.length - 1 ? 1 : items.length - 2;
          // Reposiciona sin animación para que el loop se sienta continuo (sin salto visible).
          requestAnimationFrame(function () {
            setPosition(false);
          });
        }
      });

      function start() {
        stop();
        if (interval > 0) {
          timer = setInterval(goNext, interval);
        }
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          setPosition(false);
        }, 100);
      });

      setPosition(false);
      start();

      viewport.addEventListener('mouseenter', stop);
      viewport.addEventListener('mouseleave', start);

      // Deslizar con el dedo/mouse para pasar al testimonio anterior o siguiente.
      var dragStartX = null;
      var dragMoved = false;

      viewport.addEventListener(
        'touchstart',
        function (event) {
          stop();
          dragStartX = event.touches[0].clientX;
          dragMoved = false;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        function (event) {
          if (dragStartX === null) return;
          if (Math.abs(event.touches[0].clientX - dragStartX) > 10) dragMoved = true;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (event) {
          if (dragStartX !== null && dragMoved) {
            var deltaX = event.changedTouches[0].clientX - dragStartX;
            if (Math.abs(deltaX) > 40) {
              if (deltaX < 0) {
                goNext();
              } else {
                goPrev();
              }
            }
          }
          dragStartX = null;
          start();
        },
        { passive: true }
      );

      // Clic en las tarjetas asomando a los costados salta directo a esa tarjeta.
      track.addEventListener('click', function (event) {
        var card = event.target.closest('.testimonial-card');
        if (!card || card.hasAttribute('aria-hidden')) return;
        var clickedIndex = items.indexOf(card);
        if (clickedIndex === -1 || clickedIndex === index) return;
        stop();
        goTo(clickedIndex);
        start();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
